import type { Entries } from 'type-fest';
import mergeWith from 'lodash/mergeWith';
import { isDate } from '@/utils/dates/dates';

export const sortByKeyCaseInSensitive = <T>(
  obj: Record<string, T>,
): Record<string, T> =>
  Object.keys(obj)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
    .reduce(
      (acc, key) => ({
        ...acc,
        [key]: obj[key],
      }),
      {},
    );

// returns properly types key/value pairs for Object.entries
export const getEntries = <T extends object>(obj: T) =>
  Object.entries(obj) as Entries<T>;

export const getKeys = <T extends object>(obj: T) =>
  Object.keys(obj) as unknown as Array<keyof typeof obj>;

export const mergeWithDeep = (base: unknown, source: unknown): unknown =>
  mergeWith(base, source, (baseValue: unknown, sourceValue: unknown) => {
    if (
      Array.isArray(sourceValue) &&
      sourceValue.length === 0 &&
      !Array.isArray(baseValue)
    ) {
      return baseValue;
    }

    if (
      typeof baseValue === 'object' &&
      baseValue !== null &&
      !Array.isArray(baseValue)
    ) {
      return isDate(baseValue)
        ? sourceValue
        : mergeWithDeep(baseValue, sourceValue);
    }

    if (typeof baseValue !== typeof sourceValue) {
      return baseValue !== null && baseValue !== undefined
        ? baseValue
        : sourceValue;
    }

    return sourceValue;
  });
